
import { PropType, defineComponent } from 'vue';

// Constants
import MfaConstants from 'client/containers/Login/MfaConstants';

// Utils
import { webAuthnSupported } from 'client/util/FeatureSupport';

import { cancelPoll } from 'client/containers/Login/poll';
import { useMfaLabels } from 'client/util/Constants/MfaLabels';
import type { MfaFactor } from 'client/types/Auth';

export default defineComponent({
  name: 'MfaChooser',

  props: {
    deferredBackupFactors: {
      type: Array as PropType<MfaFactor[]>,
      default: (): MfaFactor[] => [],
    },
    hasSelectedFactor: {
      type: Boolean,
      required: true,
    },
    primaryFactors: {
      type: Array as PropType<MfaFactor[]>,
      required: true,
    },
  },

  setup() {
    const uiLabel = useMfaLabels();
    return { uiLabel };
  },

  data() {
    return {
      isUserRequestingAlternateMfaMethod: false,
      revealedDeferredBackup: false,
    };
  },

  computed: {
    isToggleAllowed() {
      return this.hasSelectedFactor && !this.isUserRequestingAlternateMfaMethod;
    },

    /** Empty-selection picker with SMS (etc.) behind reveal link. */
    usesDeferredBackupLayout(): boolean {
      return !this.hasSelectedFactor && this.deferredBackupFactors.length > 0;
    },

    showRevealDeferredBackupLink(): boolean {
      return (
        this.usesDeferredBackupLayout
        && !this.revealedDeferredBackup
        && this.deferredBackupFactors.length > 0
      );
    },

    isWebAuthnSupported() {
      return webAuthnSupported();
    },

    webauthn() {
      return MfaConstants.mfaNames.webauthn;
    },
  },

  watch: {
    deferredBackupFactors() {
      this.revealedDeferredBackup = false;
    },
    hasSelectedFactor() {
      this.revealedDeferredBackup = false;
      this.isUserRequestingAlternateMfaMethod = false;
    },
    primaryFactors() {
      this.revealedDeferredBackup = false;
    },
  },

  methods: {
    request(factorName: string) {
      cancelPoll();

      this.$emit('changeFactor', factorName);
    },

    handleDisplayOptions() {
      this.isUserRequestingAlternateMfaMethod = true;
    },

    revealDeferredBackupFactors() {
      this.revealedDeferredBackup = true;
    },
  },
});
